<template>
    <component :is="is" class="ui-heading" :class="classes">
        <slot />
    </component>
</template>

<script setup lang="ts">
    import type { UIHeadingProps } from '~/src/shared/components/ui/typography/UIHeading/types'

    const props = withDefaults(defineProps<UIHeadingProps>(), {
        level: '1',
        weight: 'bold',
        align: 'left',
        size: 'small',
    })

    const is = computed(() => `h${props.level}`)

    const classes = computed(() => ({
        [`h${props.level}`]: props.level,
        [`_${props.align}`]: props.align,
    }))
</script>

<style scoped lang="scss">
    .ui-heading {
        &._left {
            text-align: left;
        }

        &._center {
            text-align: center;
        }

        &._right {
            text-align: right;
        }
    }
</style>
